import { render, staticRenderFns } from "./TemplatePageP3.vue?vue&type=template&id=e6cf2b2e&"
import script from "./TemplatePageP3.vue?vue&type=script&lang=js&"
export * from "./TemplatePageP3.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePageP3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports